import React from "react";
import { DateTime } from "luxon";
import useStore from "../../../../context/useStore";
import { Pill } from "../../../common/DataList";

const Fact = ({ label, children }) => (
  <div>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </div>
);

const RecipientRdvResult = ({ rdv }) => {
  const [state] = useStore();
  const constants = state.constants.items;
  const results = rdv.result;

  const getRdvResult = () => {
    switch (results.status) {
      case 2:
        return (
          <Fact label="Nouveau RDV prévu le">
            {results.newDate
              ? DateTime.fromISO(results.newDate).toFormat("dd/MM/yyyy HH:mm")
              : "Aucune date"}
          </Fact>
        );

      case 3:
        return <Fact label="Réorientation vers">{results.newOrientation}</Fact>;

      case 4:
        return (
          <>
            <Fact label="Annulation par">
              {results.cancelOrigin ? results.cancelOrigin : "Inconnu"}
            </Fact>
            {results.cancelReason ? (
              <Fact label="Motif">
                {constants.RDV_REPORT_TYPES.find((r) => r.id == results.cancelReason)?.name}
              </Fact>
            ) : null}
          </>
        );

      case 8:
        return (
          <Fact label="Motif de sortie">
            {constants.RDV_EXIT_REASONS.find((ex) => ex.id == results.exitReason)?.name}
          </Fact>
        );

      default:
        return null;
    }
  };

  return (
    <div className="rdv-card__result">
      <h5 className="rdv-card__result-title">
        <i className="fa fa-check-circle" aria-hidden="true" />
        Rendez-vous terminé
      </h5>
      <dl className="rdv-card__facts">
        <Fact label="Statut">
          {constants.RDV_CLOSE_TYPES.find((ct) => ct.id == results.status)?.name}
        </Fact>
        {getRdvResult()}
      </dl>

      {results.status === 8 && results.exitSocialResults && results.exitSocialResults.length > 0 && (
        <div>
          <Pill tone="muted">Social</Pill>
          <ul className="rdv-card__fact-list">
            {results.exitSocialResults.map((result) => (
              <li key={`socialres${result.id}`}>
                {constants.RDV_EXIT_SOCIAL_RESULTS.find((r) => r.id == result)?.name}
              </li>
            ))}
          </ul>
        </div>
      )}
      {results.status === 8 && results.exitProResults && results.exitProResults.length > 0 && (
        <div>
          <Pill tone="muted">Socio-professionnel</Pill>
          <ul className="rdv-card__fact-list">
            {results.exitProResults.map((result) => (
              <li key={`prores${result.id}`}>
                {constants.RDV_EXIT_PRO_RESULTS.find((r) => r.id == result)?.name}
              </li>
            ))}
          </ul>
        </div>
      )}
      {results.status === 8 && results.newOrientation && (
        <dl className="rdv-card__facts">
          <Fact label="Réorienté vers">{results.newOrientation}</Fact>
        </dl>
      )}

      {results.comment && results.comment != "" ? (
        <p className="rdv-card__quote">
          <i className="far fa-comment mr-2" aria-hidden="true" />
          <strong>Agent</strong> — {results.comment}
        </p>
      ) : null}
    </div>
  );
};

export default RecipientRdvResult;
